import { ChecklistItem } from '@/src/common/modules/OnboardingChecklist/ChecklistItem'
import { formatCurrency } from '@/src/common/utils/general'
import { styles } from '@/src/common/modules/OnboardingChecklist/styles'
import { formatToTextMonth } from '@/src/common/utils/date'
import { Text } from 'react-native'
import { Progress } from 'tamagui'

const MORTGAGE_EARN_SPEND_AMOUNT_THRESHOLD = 1000

export function ProgressChecklistItem({
  periodStart,
  periodEnd,
  isEnrolled,
  statementSpend,
  statementSpendRemaining,
}: {
  periodStart: Date | string | undefined
  periodEnd: Date | string | undefined
  isEnrolled: boolean
  statementSpend: number
  statementSpendRemaining: number
}) {
  if (!isEnrolled) {
    return null
  }

  const hasReachedMortgageEarnSpend = statementSpendRemaining === 0
  const percentageSpend = Math.min(statementSpend / MORTGAGE_EARN_SPEND_AMOUNT_THRESHOLD, 1)
  const statementSpendDisplay = formatCurrency(statementSpend.toString(), {
    isFloat: true,
    minimumFractionDigits: 2,
    decimals: null,
  })
  const thresholdDisplay = formatCurrency(MORTGAGE_EARN_SPEND_AMOUNT_THRESHOLD.toString(), {
    isFloat: true,
    minimumFractionDigits: 0,
    decimals: null,
  })

  const statementCycleDescription =
    periodStart && periodEnd
      ? ` within your current statement cycle (${formatToTextMonth(
          new Date(periodStart),
        )} to ${formatToTextMonth(new Date(periodEnd))})`
      : '.'

  const backgroundColor = hasReachedMortgageEarnSpend ? '#00DFC9' : '#E78A43'

  return (
    <ChecklistItem
      title="Track Your Spend"
      description={`To earn mortgage points, make at least $1,000 in eligible purchases${statementCycleDescription}`}
      status={hasReachedMortgageEarnSpend ? 'complete' : 'incomplete'}
    >
      <Progress
        style={{ backgroundColor: `${backgroundColor}40`, height: 4 }}
        value={percentageSpend * 100}
      >
        <Progress.Indicator style={{ backgroundColor }} />
      </Progress>
      <Text style={styles.subtitle}>
        {statementSpendDisplay} / {thresholdDisplay}
      </Text>
    </ChecklistItem>
  )
}
